<template>
    <div
        class="modal modal-side modal-right modal-profile primary fade"
        :class="{ 'show': isVisibleModalUser }"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="header-text">
                        <div class="title" style="cursor: pointer;">
                            <h2>Dados da Conta</h2>
                        </div>
                    </div>
                    <div class="header-button">
                        <div class="button">
                            <button
                                type="button"
                                class="btn btn-block btn-header"
                                @click="closeModalUser"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M5.71875 4.28087C5.31899 3.89979 4.67835 3.90746 4.28783 4.29798C3.8973 4.6885 3.90478 5.31401 4.30453 5.69508L10.9059 11.988L4.30453 18.2809C3.90478 18.6619 3.8973 19.2874 4.28783 19.678C4.67835 20.0685 5.31899 20.0762 5.71875 19.6951L12.3547 13.3691L18.7808 19.495C19.1806 19.8761 19.8212 19.8684 20.2117 19.4779C20.6023 19.0873 20.5948 18.4618 20.195 18.0808L13.8036 11.988L20.195 5.89518C20.5948 5.51411 20.6023 4.8886 20.2117 4.49808C19.8212 4.10755 19.1806 4.09989 18.7808 4.48097L12.3547 10.6068L5.71875 4.28087Z"
                                        fill="#C4C4C4"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="body-wrapper primary">
                        <div class="wrapper-inner">
                            <div class="body-avatar">
                                <div class="avatar-image">
                                    <div class="image">
                                        <img
                                            src="assets/images/root/icon-profile-1.png"
                                        />
                                    </div>
                                    <div class="icon">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="19"
                                            viewBox="0 0 19 19"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M15.6093 3.00469C15.0694 2.4612 14.1212 2.46417 13.5858 3.00239L6.08439 10.4813V13.7839L9.35123 13.7727L16.8506 6.29585C17.1216 6.02291 17.2708 5.66077 17.2708 5.275C17.2708 4.8891 17.1218 4.52713 16.8506 4.25416L15.6093 3.00469ZM14.5967 3.83866L16.0269 5.2729L14.5898 6.70595L13.1622 5.26989L14.5967 3.83866ZM12.2372 6.19091L13.6647 7.62785L8.81435 12.4633L7.38541 12.4679V11.0287L12.2372 6.19091ZM4.92136 3.49349C3.62574 3.49349 2.57544 4.54379 2.57544 5.83941V14.9471C2.57544 16.2427 3.62574 17.293 4.92136 17.293H14.0291C15.3247 17.293 16.375 16.2427 16.375 14.9471V10.8043C16.375 10.3989 16.0464 10.0703 15.641 10.0703C15.2356 10.0703 14.907 10.3989 14.907 10.8043V14.9471C14.907 15.432 14.5139 15.825 14.0291 15.825H4.92136C4.43652 15.825 4.04348 15.432 4.04348 14.9471V5.83941C4.04348 5.35457 4.43652 4.96153 4.92136 4.96153H9.47521C9.8806 4.96153 10.2092 4.63289 10.2092 4.22751C10.2092 3.82212 9.8806 3.49349 9.47521 3.49349H4.92136Z"
                                                fill="#212226"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div class="avatar-form">
                                    <div class="form-group">
                                        <div class="form-file">
                                            <input
                                                type="file"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="body-form">
                                <div class="row">
                                    <div
                                        class="col-form-outer col-12 col-md-12 col-lg-12"
                                    >
                                        <div class="row">
                                            <div
                                                class="col-form-inner col-12 col-md-6 col-lg-6"
                                            >
                                                <div
                                                    class="form-group"
                                                >
                                                    <div
                                                        class="form-label"
                                                    >
                                                        <label>
                                                            Nome
                                                        </label>
                                                    </div>
                                                    <div
                                                        class="form-input"
                                                    >
                                                        <input
                                                            class="form-control"
                                                            type="text"
                                                            :value="userData.name"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-form-inner col-12 col-md-6 col-lg-6"
                                            >
                                                <div
                                                    class="form-group"
                                                >
                                                    <div
                                                        class="form-label"
                                                    >
                                                        <label>
                                                            E-mail
                                                        </label>
                                                    </div>
                                                    <div
                                                        class="form-input"
                                                    >
                                                        <input
                                                            class="form-control"
                                                            type="email"
                                                            :value="userData.email"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-form-outer col-12 col-md-12 col-lg-12">
                                        <div class="row">
                                            <div class="col-form-inner col-12 col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <div class="form-label">
                                                        <label>
                                                            Data de nascimento
                                                        </label>
                                                    </div>
                                                    <div class="form-input">
                                                        <input class="form-control" type="date" value="28/07/1973" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-form-inner col-12 col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <div class="form-label">
                                                        <label>
                                                            Celular
                                                        </label>
                                                    </div>
                                                    <div class="form-input">
                                                        <input class="form-control" type="text" value="(21) 9 8878-2387" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-form-inner col-12 col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <div class="form-label">
                                                        <label>
                                                            CPF
                                                        </label>
                                                    </div>
                                                    <div class="form-input">
                                                        <input class="form-control" type="text" value="178.609.147-85" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="form-button">
                                    <div class="button">
                                        <button
                                            type="button"
                                            class="btn btn-block btn-form secondary"
                                        >
                                            Sair da conta
                                        </button>
                                    </div>
                                    <div class="button">
                                        <button
                                            type="button"
                                            class="btn btn-block btn-form primary"
                                        >
                                            Salvar alterações
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wrapper-inner">
                            <div class="body-text">
                                <div class="title">
                                    <h3>Redefinir senha</h3>
                                </div>
                                <div class="desc">
                                    <p>
                                        Preencha apenas caso
                                        queira alterar sua senha
                                    </p>
                                </div>
                            </div>
                            <div class="body-form">
                                <div class="row">
                                    <div
                                        class="col-form-outer col-12 col-md-12 col-lg-12"
                                    >
                                        <div class="row">
                                            <div
                                                class="col-form-inner col-12 col-md-6 col-lg-6"
                                            >
                                                <div
                                                    class="form-group"
                                                >
                                                    <div
                                                        class="form-label"
                                                    >
                                                        <label>
                                                            Nova
                                                            senha
                                                        </label>
                                                    </div>
                                                    <div
                                                        class="form-input"
                                                    >
                                                        <input
                                                            class="form-control"
                                                            type="text"
                                                            placeholder="Defina sua nova senha"
                                                            :value="userData.password"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-form-inner col-12 col-md-6 col-lg-6"
                                            >
                                                <div
                                                    class="form-group"
                                                >
                                                    <div
                                                        class="form-label"
                                                    >
                                                        <label>
                                                            Confirmar
                                                            nova
                                                            senha
                                                        </label>
                                                    </div>
                                                    <div
                                                        class="form-input"
                                                    >
                                                        <input
                                                            class="form-control"
                                                            type="text"
                                                            placeholder="Defina sua nova senha"
                                                            :value="userData.password"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-button">
                                    <div class="button">
                                        <button
                                            type="button"
                                            class="btn btn-block btn-form primary"
                                        >
                                            Salvar senha
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import users from '../../utils/users';

export default {
    name: 'ModalUser',
    data() {
        return {
            userData: {
                name: '',
                email: '',
                password: ''
            }
        }
    },
    computed: {
        ...mapState(['user', 'token', 'isVisibleModalUser', 'userInfoData', 'isVisibleModalUser'])
    },
    methods: {
        ...mapActions(['storeIsVisibleModalUser']),
        async getUserData() {
            try {
                const response = await users.getUsersById(this.token, this.user.user_id);
                this.userData.name = response.name;
                this.userData.email = response.email;
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        },
        closeModalUser() {
            this.storeIsVisibleModalUser({ isVisibleModalUser: false });
        }   
    },
    mounted() {
        this.getUserData();
    }
}
</script>

<style lang="scss" scoped></style>